import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import OpeningPage from './pages/OpeningPage';
import Guide01Page from './pages/01GuidePage';
import RegisterPage from './pages/02RegisterPage';
import ContractPage from './pages/03Contract';
import ChannelOpenPage from './pages/04ChannelOpen';
import TaleHousePage from './pages/05TaleHouse';
import Quiz1Page from './pages/06Quiz1';
import Quiz2Page from './pages/07Quiz2';
import Quiz3Page from './pages/08Quiz3';
import Quiz4Page from './pages/09Quiz4';
import Quiz5Page from './pages/10Quiz5';
import Quiz6Page from './pages/11Quiz6';
import ProgressCardPage from './pages/ProgressCardPage';
import ConstellationParty from './pages/12ConstellationParty';
import TestPage from './pages/TestPage';
import UrlGeneratorPage from './pages/UrlGeneratorPage';
import TimeUrlGeneratorPage from './pages/TimeUrlGeneratorPage';
import MessageSend from './pages/13MessageSend';
import EndingPage from './pages/EndingPage';
import AdPage from './pages/AdPage';
import BulkMessageTestPage from './pages/BulkMessageTestPage';
import FunnelDashboardPage from './pages/FunnelDashboardPage';
import FirebaseErrorTestPage from './pages/FirebaseErrorTestPage';
import MobileOnly from './components/MobileOnly';
import MessageReceiver from './components/MessageReceiver';
import PeriodicMessagePopup from './components/PeriodicMessagePopup';
import { usePeriodicPopup } from './hooks/usePeriodicPopup';
import { testSound } from './utils/soundUtils';

function App() {
  // 주기적 팝업 훅 사용
  const { showPopup, handlePopupClose } = usePeriodicPopup({
    intervalMinutes: process.env.NODE_ENV === 'development' ? 1 : 10, // 개발 환경에서는 1분, 프로덕션에서는 10분
    enabled: true
  });


  // 개발 환경에서 사운드 테스트 함수를 전역으로 노출
  if (process.env.NODE_ENV === 'development') {
    (window as any).testSound = testSound;
  }

  return (
    <>
      <Routes>
        {/* url-generator, analytics, bulk-message-test는 데스크톱에서도 접근 가능 */}
        <Route path="/url-generator" element={<UrlGeneratorPage />} />
        <Route path="/bulk-message-test" element={<BulkMessageTestPage />} />
        <Route path="/funnel-dashboard" element={<FunnelDashboardPage />} />
        <Route path="/firebase-error-test" element={<FirebaseErrorTestPage />} />
        
        {/* register와 constellation-party는 MobileOnly 없이 접근 가능 */}
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/constellation-party" element={<ConstellationParty />} />
        
        {/* 나머지 페이지들은 모바일 전용 */}
        <Route path="/*" element={
          <>
            <MessageReceiver />
            <MobileOnly>
              <Routes>
                <Route path="/" element={<OpeningPage />} />
                <Route path="/guide01" element={<Guide01Page />} />
                <Route path="/contract" element={<ContractPage />} />
                <Route path="/channel-open" element={<ChannelOpenPage />} />
                <Route path="/tale-house" element={<TaleHousePage />} />
                <Route path="/quiz1" element={<Quiz1Page />} />
                <Route path="/quiz2" element={<Quiz2Page />} />
                <Route path="/quiz3" element={<Quiz3Page />} />
                <Route path="/quiz4" element={<Quiz4Page />} />
                <Route path="/quiz5" element={<Quiz5Page />} />
                <Route path="/quiz6" element={<Quiz6Page />} />
                <Route path="/progress-card" element={<ProgressCardPage />} />
                <Route path="/test" element={<TestPage />} />
                <Route path="/time-url-generator" element={<TimeUrlGeneratorPage />} />
                <Route path="/message-send" element={<MessageSend />} />
                <Route path="/ending" element={<EndingPage />} />
                <Route path="/ad" element={<AdPage />} />
              </Routes>
            </MobileOnly>
          </>
        } />
      </Routes>
      
      {/* 주기적 메시지 팝업 */}
      <PeriodicMessagePopup 
        isVisible={showPopup} 
        onClose={handlePopupClose} 
      />
    </>
  );
}

export default App;
